// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaregiverInfoModule-module__font-s-10___gcV9d {
  font-size: 10px !important;
}

.CaregiverInfoModule-module__font-s-12___EOA7u {
  font-size: 12px !important;
}

.CaregiverInfoModule-module__font-s-13___litee {
  font-size: 13px !important;
}

.CaregiverInfoModule-module__font-s-14___Gvf2J {
  font-size: 14px !important;
}

.CaregiverInfoModule-module__font-s-15___QJcwa {
  font-size: 15px !important;
}

.CaregiverInfoModule-module__font-s-16___iXGfL {
  font-size: 16px !important;
}

.CaregiverInfoModule-module__font-s-18___eiZzD {
  font-size: 18px !important;
}

.CaregiverInfoModule-module__font-s-20___ENyM1 {
  font-size: 20px !important;
}

.CaregiverInfoModule-module__font-s-22___S7iyB {
  font-size: 22px !important;
}

.CaregiverInfoModule-module__font-s-28___SytlZ {
  font-size: 28px !important;
}

.CaregiverInfoModule-module__font-w-400___FkmtM {
  font-weight: 400 !important;
}

.CaregiverInfoModule-module__font-w-500___qQllg {
  font-weight: 500 !important;
}

.CaregiverInfoModule-module__font-w-600___cw4tm {
  font-weight: 600 !important;
}

.CaregiverInfoModule-module__font-w-700___VR6yY {
  font-weight: 700 !important;
}

.CaregiverInfoModule-module__p-5___IHUPM {
  padding: 5px !important;
}

.CaregiverInfoModule-module__p-12___UFucs {
  padding: 12px !important;
}

.CaregiverInfoModule-module__p-16___bcHrO {
  padding: 16px !important;
}

.CaregiverInfoModule-module__p-30___TFXcb {
  padding: 30px !important;
}

.CaregiverInfoModule-module__p-b-0___t_aw9 {
  padding-bottom: 0 !important;
}

.CaregiverInfoModule-module__p-b-5___jetTJ {
  padding-bottom: 5px !important;
}

.CaregiverInfoModule-module__p-b-10___XHlPI {
  padding-bottom: 10px !important;
}

.CaregiverInfoModule-module__p-b-12___IhQBf {
  padding-bottom: 12px !important;
}

.CaregiverInfoModule-module__p-b-16___zv927 {
  padding-bottom: 16px !important;
}

.CaregiverInfoModule-module__p-b-18___wSsU5 {
  padding-bottom: 18px !important;
}

.CaregiverInfoModule-module__p-b-20___ofNf9 {
  padding-bottom: 20px !important;
}

.CaregiverInfoModule-module__p-b-25___cKEqw {
  padding-bottom: 25px !important;
}

.CaregiverInfoModule-module__p-b-30___NvYnF {
  padding-bottom: 30px !important;
}

.CaregiverInfoModule-module__p-b-50___SNRCs {
  padding-bottom: 50px !important;
}

.CaregiverInfoModule-module__p-t-0___lcVcT {
  padding-top: 0 !important;
}

.CaregiverInfoModule-module__p-t-12___L2DFN {
  padding-top: 12px !important;
}

.CaregiverInfoModule-module__p-t-16___GgE6a {
  padding-top: 16px !important;
}

.CaregiverInfoModule-module__p-t-18___Jt3fw {
  padding-top: 18px !important;
}

.CaregiverInfoModule-module__p-t-20___vX9Cp {
  padding-top: 20px !important;
}

.CaregiverInfoModule-module__p-t-30___elesi {
  padding-top: 30px !important;
}

.CaregiverInfoModule-module__p-t-40___lM_UK {
  padding-top: 40px !important;
}

.CaregiverInfoModule-module__p-t-50___TnKuM {
  padding-top: 50px !important;
}

.CaregiverInfoModule-module__p-l-20___wbhq2 {
  padding-left: 20px !important;
}

.CaregiverInfoModule-module__p-l-30___O_M7V {
  padding-left: 30px !important;
}

.CaregiverInfoModule-module__p-l-40___KFB7G {
  padding-left: 40px !important;
}

.CaregiverInfoModule-module__p-r-16___sytT6 {
  padding-right: 16px !important;
}

.CaregiverInfoModule-module__p-r-20___W6wiu {
  padding-right: 20px !important;
}

.CaregiverInfoModule-module__p-r-30___zUqNP {
  padding-right: 30px !important;
}

.CaregiverInfoModule-module__p-r-50___ZvKKM {
  padding-right: 50px !important;
}

.CaregiverInfoModule-module__p-r-60___LDiwc {
  padding-right: 60px !important;
}

.CaregiverInfoModule-module__m-b-1___ctJfR {
  margin-bottom: 1px !important;
}

.CaregiverInfoModule-module__m-b-2___E5PAB {
  margin-bottom: 2px !important;
}

.CaregiverInfoModule-module__m-b-6___RN83j {
  margin-bottom: 6px !important;
}

.CaregiverInfoModule-module__m-b-8___LdBBK {
  margin-bottom: 8px !important;
}

.CaregiverInfoModule-module__m-b-10___Lkqh2 {
  margin-bottom: 10px !important;
}

.CaregiverInfoModule-module__m-b-14___th0v1 {
  margin-bottom: 14px !important;
}

.CaregiverInfoModule-module__m-b-16___rtNAL {
  margin-bottom: 16px !important;
}

.CaregiverInfoModule-module__m-b-20___tSd0g {
  margin-bottom: 20px !important;
}

.CaregiverInfoModule-module__m-b-22___apU82 {
  margin-bottom: 22px !important;
}

.CaregiverInfoModule-module__m-b-24___xxfgF {
  margin-bottom: 24px !important;
}

.CaregiverInfoModule-module__m-b-30___rUgT9 {
  margin-bottom: 30px !important;
}

.CaregiverInfoModule-module__m-b-32___wleJp {
  margin-bottom: 32px !important;
}

.CaregiverInfoModule-module__m-b-40___Oin3e {
  margin-bottom: 40px !important;
}

.CaregiverInfoModule-module__m-t-2___kFHTU {
  margin-top: 2px !important;
}

.CaregiverInfoModule-module__m-t-3___ftyah {
  margin-top: 3px !important;
}

.CaregiverInfoModule-module__m-t-4___HSW_C {
  margin-top: 4px !important;
}

.CaregiverInfoModule-module__m-t-5___Go9Fg {
  margin-top: 5px !important;
}

.CaregiverInfoModule-module__m-t-8___SruvO {
  margin-top: 8px !important;
}

.CaregiverInfoModule-module__m-t-10___ftA2r {
  margin-top: 10px !important;
}

.CaregiverInfoModule-module__m-t-15___TS8Ry {
  margin-top: 15px !important;
}

.CaregiverInfoModule-module__m-t-16___FA8uO {
  margin-top: 16px !important;
}

.CaregiverInfoModule-module__m-t-20___iFYVI {
  margin-top: 20px !important;
}

.CaregiverInfoModule-module__m-t-22___tquI6 {
  margin-top: 22px !important;
}

.CaregiverInfoModule-module__m-t-30___nzEQR {
  margin-top: 30px !important;
}

.CaregiverInfoModule-module__m-t-32___i9n_X {
  margin-top: 32px !important;
}

.CaregiverInfoModule-module__m-l-auto___orLoY {
  margin-left: auto !important;
}

.CaregiverInfoModule-module__m-l-4___TawCF {
  margin-left: 4px !important;
}

.CaregiverInfoModule-module__m-l-5___navP8 {
  margin-left: 5px !important;
}

.CaregiverInfoModule-module__m-l-6___ZVdZG {
  margin-left: 6px !important;
}

.CaregiverInfoModule-module__m-l-8___M9DlI {
  margin-left: 8px !important;
}

.CaregiverInfoModule-module__m-l-10___zcsEL {
  margin-left: 10px !important;
}

.CaregiverInfoModule-module__m-l-16___Smt_s {
  margin-left: 16px !important;
}

.CaregiverInfoModule-module__m-l-20___vroJu {
  margin-left: 20px !important;
}

.CaregiverInfoModule-module__m-l-24___JmG4g {
  margin-left: 24px !important;
}

.CaregiverInfoModule-module__m-l-30___TeNym {
  margin-left: 30px !important;
}

.CaregiverInfoModule-module__m-l-35___ZOP_K {
  margin-left: 35px !important;
}

.CaregiverInfoModule-module__m-l-40___SkHUq {
  margin-left: 40px !important;
}

.CaregiverInfoModule-module__m-r-8___wcXRD {
  margin-right: 8px !important;
}

.CaregiverInfoModule-module__m-r-10___peBaS {
  margin-right: 10px !important;
}

.CaregiverInfoModule-module__m-r-16___qYidy {
  margin-right: 16px !important;
}

.CaregiverInfoModule-module__m-r-20___XQr20 {
  margin-right: 20px !important;
}

.CaregiverInfoModule-module__m-r-24___KG2pX {
  margin-right: 24px !important;
}

.CaregiverInfoModule-module__m-r-30___dSAXA {
  margin-right: 30px !important;
}

.CaregiverInfoModule-module__m-r-40___q4l5K {
  margin-right: 40px !important;
}

.CaregiverInfoModule-module__border-r-3___IAq70 {
  border-radius: 3px !important;
}

.CaregiverInfoModule-module__border-r-4___IcRJi {
  border-radius: 4px !important;
}

.CaregiverInfoModule-module__border-r-6___gKLZG {
  border-radius: 6px !important;
}

.CaregiverInfoModule-module__border-r-10___R1eKh {
  border-radius: 10px !important;
}

.CaregiverInfoModule-module__border-r-12___8sa9j {
  border-radius: 12px !important;
}

.CaregiverInfoModule-module__border-r-16___ET88Q {
  border-radius: 16px !important;
}

.CaregiverInfoModule-module__border-r-50___sbchg {
  border-radius: 50% !important;
}

.CaregiverInfoModule-module__primary-border___eSdlA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CaregiverInfoModule-module__primary-border-b___xiAc1 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CaregiverInfoModule-module__primary-border-t___ItCiE {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CaregiverInfoModule-module__primary-border-l___J8Mv_ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CaregiverInfoModule-module__primary-border-r___bRhXD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CaregiverInfoModule-module__secondary-border___yKvh8 {
  border: 1px solid #637768;
}

.CaregiverInfoModule-module__secondary-border-b___EzDSj {
  border-bottom: 1px solid #637768;
}

.CaregiverInfoModule-module__secondary-border-t___DLjxo {
  border-top: 1px solid #637768;
}

.CaregiverInfoModule-module__secondary-border-l___d7Ujp {
  border-left: 1px solid #637768;
}

.CaregiverInfoModule-module__secondary-border-r___x9jxL {
  border-right: 1px solid #637768;
}

.CaregiverInfoModule-module__gap-0___Wxe67 {
  gap: 0 !important;
}

.CaregiverInfoModule-module__gap-2___WCMx9 {
  gap: 2px !important;
}

.CaregiverInfoModule-module__gap-4___UBOOY {
  gap: 4px !important;
}

.CaregiverInfoModule-module__gap-5___dPta8 {
  gap: 5px !important;
}

.CaregiverInfoModule-module__gap-6___LCNl1 {
  gap: 6px !important;
}

.CaregiverInfoModule-module__gap-8___Ef2JK {
  gap: 8px !important;
}

.CaregiverInfoModule-module__gap-10___xhFNj {
  gap: 10px !important;
}

.CaregiverInfoModule-module__gap-12___e5ArR {
  gap: 12px !important;
}

.CaregiverInfoModule-module__gap-14___z2uKV {
  gap: 14px !important;
}

.CaregiverInfoModule-module__gap-16___EqkxV {
  gap: 16px !important;
}

.CaregiverInfoModule-module__gap-18___VifPq {
  gap: 18px !important;
}

.CaregiverInfoModule-module__gap-20___F098X {
  gap: 20px !important;
}

.CaregiverInfoModule-module__gap-24___gLhuR {
  gap: 24px !important;
}

.CaregiverInfoModule-module__gap-26___bLkN2 {
  gap: 26px !important;
}

.CaregiverInfoModule-module__gap-30___H3t43 {
  gap: 30px !important;
}

.CaregiverInfoModule-module__gap-32___J06Sg {
  gap: 32px !important;
}

.CaregiverInfoModule-module__gap-40___G4CLd {
  gap: 40px !important;
}

.CaregiverInfoModule-module__gap-50___sILMl {
  gap: 50px !important;
}

.CaregiverInfoModule-module__flex-1___GCzu1 {
  flex: 1;
}

.CaregiverInfoModule-module__flex-none___BuaRK {
  flex: none !important;
}

.CaregiverInfoModule-module__flex-column___PZXKG {
  display: flex;
  flex-direction: column !important;
}

.CaregiverInfoModule-module__flex-row___jhrjT {
  display: flex;
  flex-direction: row !important;
}

.CaregiverInfoModule-module__vertically-centered___YHeIs {
  display: flex;
  align-items: center !important;
}

.CaregiverInfoModule-module__horizontally-centered___Ptayk {
  display: flex;
  justify-content: center !important;
}

.CaregiverInfoModule-module__horizontally-end___bi9dU {
  display: flex;
  justify-content: end !important;
}

.CaregiverInfoModule-module__vertically-start___T5UCt {
  display: flex;
  align-items: start !important;
}

.CaregiverInfoModule-module__space-between___bBolf {
  display: flex;
  justify-content: space-between !important;
}

.CaregiverInfoModule-module__flex-wrap___WGANm {
  flex-wrap: wrap !important;
}

.CaregiverInfoModule-module__height-100___DvpSf {
  height: 100%;
}

.CaregiverInfoModule-module__width-50___S4oBV {
  width: 50% !important;
}

.CaregiverInfoModule-module__width-100___Ap7HA {
  width: 100%;
}

.CaregiverInfoModule-module__cursor-pointer___yjKp_ {
  cursor: pointer;
}

.CaregiverInfoModule-module__cursor-not-allowed___C8CrU {
  cursor: not-allowed !important;
}

.CaregiverInfoModule-module__absolute-centered___cpj7l {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CaregiverInfoModule-module__absolute___thyg7 {
  position: absolute;
}

.CaregiverInfoModule-module__relative___XVA4i {
  position: relative;
}

.CaregiverInfoModule-module__fixed___HRleh {
  position: fixed;
}

.CaregiverInfoModule-module__visible___B_jJB {
  opacity: 1;
}

.CaregiverInfoModule-module__invisible___crEp1 {
  opacity: 0;
}

.CaregiverInfoModule-module__col-90___ZkGv1 {
  width: 90% !important;
}

.CaregiverInfoModule-module__col-auto___k1J5c {
  width: auto !important;
}

.CaregiverInfoModule-module__medical-tabs___VnndP {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CaregiverInfoModule-module__medical-table-new___NArSn {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CaregiverInfoModule-module__medical-table-new___NArSn:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CaregiverInfoModule-module__medical-table-new___NArSn::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CaregiverInfoModule-module__medical-table-new___NArSn::-webkit-scrollbar-track {
  display: none;
}
.CaregiverInfoModule-module__medical-table-new___NArSn.CaregiverInfoModule-module__no-pagination___KYLg7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CaregiverInfoModule-module__medical-table-new___NArSn.CaregiverInfoModule-module__no-pagination___KYLg7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CaregiverInfoModule-module__medical-table-new___NArSn.CaregiverInfoModule-module__no-pagination___KYLg7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CaregiverInfoModule-module__medical-table-new___NArSn.CaregiverInfoModule-module__no-pagination___KYLg7::-webkit-scrollbar-track {
  display: none;
}

.CaregiverInfoModule-module__medical-table-empty___qmoh5 {
  padding: 14px 40px !important;
}

.CaregiverInfoModule-module__icon-btn___UVB72 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CaregiverInfoModule-module__search-icon___nh74X {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CaregiverInfoModule-module__disable-select___UTcNQ {
  user-select: none;
}

.CaregiverInfoModule-module__break-word___vMVkT {
  word-break: break-word;
}

.CaregiverInfoModule-module__popup-clear-btn___W_BwP {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CaregiverInfoModule-module__scroll-m-b-20___sTUp7 {
  scroll-margin-bottom: 20px;
}

.CaregiverInfoModule-module__container___gc24O {
  color: #375844;
}
.CaregiverInfoModule-module__container___gc24O .CaregiverInfoModule-module__grid___AtIUy {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.CaregiverInfoModule-module__container___gc24O .CaregiverInfoModule-module__placeholder___owBjG {
  color: #637768;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/CaregiverInfoModule/CaregiverInfoModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,SAAA;EACA,gDAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,kBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n\n  .grid {\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .placeholder {\n    color: get-color(greenNew, medium-dark);\n    font-style: italic;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CaregiverInfoModule-module__font-s-10___gcV9d`,
	"fontS12": `CaregiverInfoModule-module__font-s-12___EOA7u`,
	"fontS13": `CaregiverInfoModule-module__font-s-13___litee`,
	"fontS14": `CaregiverInfoModule-module__font-s-14___Gvf2J`,
	"fontS15": `CaregiverInfoModule-module__font-s-15___QJcwa`,
	"fontS16": `CaregiverInfoModule-module__font-s-16___iXGfL`,
	"fontS18": `CaregiverInfoModule-module__font-s-18___eiZzD`,
	"fontS20": `CaregiverInfoModule-module__font-s-20___ENyM1`,
	"fontS22": `CaregiverInfoModule-module__font-s-22___S7iyB`,
	"fontS28": `CaregiverInfoModule-module__font-s-28___SytlZ`,
	"fontW400": `CaregiverInfoModule-module__font-w-400___FkmtM`,
	"fontW500": `CaregiverInfoModule-module__font-w-500___qQllg`,
	"fontW600": `CaregiverInfoModule-module__font-w-600___cw4tm`,
	"fontW700": `CaregiverInfoModule-module__font-w-700___VR6yY`,
	"p5": `CaregiverInfoModule-module__p-5___IHUPM`,
	"p12": `CaregiverInfoModule-module__p-12___UFucs`,
	"p16": `CaregiverInfoModule-module__p-16___bcHrO`,
	"p30": `CaregiverInfoModule-module__p-30___TFXcb`,
	"pB0": `CaregiverInfoModule-module__p-b-0___t_aw9`,
	"pB5": `CaregiverInfoModule-module__p-b-5___jetTJ`,
	"pB10": `CaregiverInfoModule-module__p-b-10___XHlPI`,
	"pB12": `CaregiverInfoModule-module__p-b-12___IhQBf`,
	"pB16": `CaregiverInfoModule-module__p-b-16___zv927`,
	"pB18": `CaregiverInfoModule-module__p-b-18___wSsU5`,
	"pB20": `CaregiverInfoModule-module__p-b-20___ofNf9`,
	"pB25": `CaregiverInfoModule-module__p-b-25___cKEqw`,
	"pB30": `CaregiverInfoModule-module__p-b-30___NvYnF`,
	"pB50": `CaregiverInfoModule-module__p-b-50___SNRCs`,
	"pT0": `CaregiverInfoModule-module__p-t-0___lcVcT`,
	"pT12": `CaregiverInfoModule-module__p-t-12___L2DFN`,
	"pT16": `CaregiverInfoModule-module__p-t-16___GgE6a`,
	"pT18": `CaregiverInfoModule-module__p-t-18___Jt3fw`,
	"pT20": `CaregiverInfoModule-module__p-t-20___vX9Cp`,
	"pT30": `CaregiverInfoModule-module__p-t-30___elesi`,
	"pT40": `CaregiverInfoModule-module__p-t-40___lM_UK`,
	"pT50": `CaregiverInfoModule-module__p-t-50___TnKuM`,
	"pL20": `CaregiverInfoModule-module__p-l-20___wbhq2`,
	"pL30": `CaregiverInfoModule-module__p-l-30___O_M7V`,
	"pL40": `CaregiverInfoModule-module__p-l-40___KFB7G`,
	"pR16": `CaregiverInfoModule-module__p-r-16___sytT6`,
	"pR20": `CaregiverInfoModule-module__p-r-20___W6wiu`,
	"pR30": `CaregiverInfoModule-module__p-r-30___zUqNP`,
	"pR50": `CaregiverInfoModule-module__p-r-50___ZvKKM`,
	"pR60": `CaregiverInfoModule-module__p-r-60___LDiwc`,
	"mB1": `CaregiverInfoModule-module__m-b-1___ctJfR`,
	"mB2": `CaregiverInfoModule-module__m-b-2___E5PAB`,
	"mB6": `CaregiverInfoModule-module__m-b-6___RN83j`,
	"mB8": `CaregiverInfoModule-module__m-b-8___LdBBK`,
	"mB10": `CaregiverInfoModule-module__m-b-10___Lkqh2`,
	"mB14": `CaregiverInfoModule-module__m-b-14___th0v1`,
	"mB16": `CaregiverInfoModule-module__m-b-16___rtNAL`,
	"mB20": `CaregiverInfoModule-module__m-b-20___tSd0g`,
	"mB22": `CaregiverInfoModule-module__m-b-22___apU82`,
	"mB24": `CaregiverInfoModule-module__m-b-24___xxfgF`,
	"mB30": `CaregiverInfoModule-module__m-b-30___rUgT9`,
	"mB32": `CaregiverInfoModule-module__m-b-32___wleJp`,
	"mB40": `CaregiverInfoModule-module__m-b-40___Oin3e`,
	"mT2": `CaregiverInfoModule-module__m-t-2___kFHTU`,
	"mT3": `CaregiverInfoModule-module__m-t-3___ftyah`,
	"mT4": `CaregiverInfoModule-module__m-t-4___HSW_C`,
	"mT5": `CaregiverInfoModule-module__m-t-5___Go9Fg`,
	"mT8": `CaregiverInfoModule-module__m-t-8___SruvO`,
	"mT10": `CaregiverInfoModule-module__m-t-10___ftA2r`,
	"mT15": `CaregiverInfoModule-module__m-t-15___TS8Ry`,
	"mT16": `CaregiverInfoModule-module__m-t-16___FA8uO`,
	"mT20": `CaregiverInfoModule-module__m-t-20___iFYVI`,
	"mT22": `CaregiverInfoModule-module__m-t-22___tquI6`,
	"mT30": `CaregiverInfoModule-module__m-t-30___nzEQR`,
	"mT32": `CaregiverInfoModule-module__m-t-32___i9n_X`,
	"mLAuto": `CaregiverInfoModule-module__m-l-auto___orLoY`,
	"mL4": `CaregiverInfoModule-module__m-l-4___TawCF`,
	"mL5": `CaregiverInfoModule-module__m-l-5___navP8`,
	"mL6": `CaregiverInfoModule-module__m-l-6___ZVdZG`,
	"mL8": `CaregiverInfoModule-module__m-l-8___M9DlI`,
	"mL10": `CaregiverInfoModule-module__m-l-10___zcsEL`,
	"mL16": `CaregiverInfoModule-module__m-l-16___Smt_s`,
	"mL20": `CaregiverInfoModule-module__m-l-20___vroJu`,
	"mL24": `CaregiverInfoModule-module__m-l-24___JmG4g`,
	"mL30": `CaregiverInfoModule-module__m-l-30___TeNym`,
	"mL35": `CaregiverInfoModule-module__m-l-35___ZOP_K`,
	"mL40": `CaregiverInfoModule-module__m-l-40___SkHUq`,
	"mR8": `CaregiverInfoModule-module__m-r-8___wcXRD`,
	"mR10": `CaregiverInfoModule-module__m-r-10___peBaS`,
	"mR16": `CaregiverInfoModule-module__m-r-16___qYidy`,
	"mR20": `CaregiverInfoModule-module__m-r-20___XQr20`,
	"mR24": `CaregiverInfoModule-module__m-r-24___KG2pX`,
	"mR30": `CaregiverInfoModule-module__m-r-30___dSAXA`,
	"mR40": `CaregiverInfoModule-module__m-r-40___q4l5K`,
	"borderR3": `CaregiverInfoModule-module__border-r-3___IAq70`,
	"borderR4": `CaregiverInfoModule-module__border-r-4___IcRJi`,
	"borderR6": `CaregiverInfoModule-module__border-r-6___gKLZG`,
	"borderR10": `CaregiverInfoModule-module__border-r-10___R1eKh`,
	"borderR12": `CaregiverInfoModule-module__border-r-12___8sa9j`,
	"borderR16": `CaregiverInfoModule-module__border-r-16___ET88Q`,
	"borderR50": `CaregiverInfoModule-module__border-r-50___sbchg`,
	"primaryBorder": `CaregiverInfoModule-module__primary-border___eSdlA`,
	"primaryBorderB": `CaregiverInfoModule-module__primary-border-b___xiAc1`,
	"primaryBorderT": `CaregiverInfoModule-module__primary-border-t___ItCiE`,
	"primaryBorderL": `CaregiverInfoModule-module__primary-border-l___J8Mv_`,
	"primaryBorderR": `CaregiverInfoModule-module__primary-border-r___bRhXD`,
	"secondaryBorder": `CaregiverInfoModule-module__secondary-border___yKvh8`,
	"secondaryBorderB": `CaregiverInfoModule-module__secondary-border-b___EzDSj`,
	"secondaryBorderT": `CaregiverInfoModule-module__secondary-border-t___DLjxo`,
	"secondaryBorderL": `CaregiverInfoModule-module__secondary-border-l___d7Ujp`,
	"secondaryBorderR": `CaregiverInfoModule-module__secondary-border-r___x9jxL`,
	"gap0": `CaregiverInfoModule-module__gap-0___Wxe67`,
	"gap2": `CaregiverInfoModule-module__gap-2___WCMx9`,
	"gap4": `CaregiverInfoModule-module__gap-4___UBOOY`,
	"gap5": `CaregiverInfoModule-module__gap-5___dPta8`,
	"gap6": `CaregiverInfoModule-module__gap-6___LCNl1`,
	"gap8": `CaregiverInfoModule-module__gap-8___Ef2JK`,
	"gap10": `CaregiverInfoModule-module__gap-10___xhFNj`,
	"gap12": `CaregiverInfoModule-module__gap-12___e5ArR`,
	"gap14": `CaregiverInfoModule-module__gap-14___z2uKV`,
	"gap16": `CaregiverInfoModule-module__gap-16___EqkxV`,
	"gap18": `CaregiverInfoModule-module__gap-18___VifPq`,
	"gap20": `CaregiverInfoModule-module__gap-20___F098X`,
	"gap24": `CaregiverInfoModule-module__gap-24___gLhuR`,
	"gap26": `CaregiverInfoModule-module__gap-26___bLkN2`,
	"gap30": `CaregiverInfoModule-module__gap-30___H3t43`,
	"gap32": `CaregiverInfoModule-module__gap-32___J06Sg`,
	"gap40": `CaregiverInfoModule-module__gap-40___G4CLd`,
	"gap50": `CaregiverInfoModule-module__gap-50___sILMl`,
	"flex1": `CaregiverInfoModule-module__flex-1___GCzu1`,
	"flexNone": `CaregiverInfoModule-module__flex-none___BuaRK`,
	"flexColumn": `CaregiverInfoModule-module__flex-column___PZXKG`,
	"flexRow": `CaregiverInfoModule-module__flex-row___jhrjT`,
	"verticallyCentered": `CaregiverInfoModule-module__vertically-centered___YHeIs`,
	"horizontallyCentered": `CaregiverInfoModule-module__horizontally-centered___Ptayk`,
	"horizontallyEnd": `CaregiverInfoModule-module__horizontally-end___bi9dU`,
	"verticallyStart": `CaregiverInfoModule-module__vertically-start___T5UCt`,
	"spaceBetween": `CaregiverInfoModule-module__space-between___bBolf`,
	"flexWrap": `CaregiverInfoModule-module__flex-wrap___WGANm`,
	"height100": `CaregiverInfoModule-module__height-100___DvpSf`,
	"width50": `CaregiverInfoModule-module__width-50___S4oBV`,
	"width100": `CaregiverInfoModule-module__width-100___Ap7HA`,
	"cursorPointer": `CaregiverInfoModule-module__cursor-pointer___yjKp_`,
	"cursorNotAllowed": `CaregiverInfoModule-module__cursor-not-allowed___C8CrU`,
	"absoluteCentered": `CaregiverInfoModule-module__absolute-centered___cpj7l`,
	"absolute": `CaregiverInfoModule-module__absolute___thyg7`,
	"relative": `CaregiverInfoModule-module__relative___XVA4i`,
	"fixed": `CaregiverInfoModule-module__fixed___HRleh`,
	"visible": `CaregiverInfoModule-module__visible___B_jJB`,
	"invisible": `CaregiverInfoModule-module__invisible___crEp1`,
	"col90": `CaregiverInfoModule-module__col-90___ZkGv1`,
	"colAuto": `CaregiverInfoModule-module__col-auto___k1J5c`,
	"medicalTabs": `CaregiverInfoModule-module__medical-tabs___VnndP`,
	"medicalTableNew": `CaregiverInfoModule-module__medical-table-new___NArSn`,
	"noPagination": `CaregiverInfoModule-module__no-pagination___KYLg7`,
	"medicalTableEmpty": `CaregiverInfoModule-module__medical-table-empty___qmoh5`,
	"iconBtn": `CaregiverInfoModule-module__icon-btn___UVB72`,
	"searchIcon": `CaregiverInfoModule-module__search-icon___nh74X`,
	"disableSelect": `CaregiverInfoModule-module__disable-select___UTcNQ`,
	"breakWord": `CaregiverInfoModule-module__break-word___vMVkT`,
	"popupClearBtn": `CaregiverInfoModule-module__popup-clear-btn___W_BwP`,
	"scrollMB20": `CaregiverInfoModule-module__scroll-m-b-20___sTUp7`,
	"container": `CaregiverInfoModule-module__container___gc24O`,
	"grid": `CaregiverInfoModule-module__grid___AtIUy`,
	"placeholder": `CaregiverInfoModule-module__placeholder___owBjG`
};
module.exports = ___CSS_LOADER_EXPORT___;
